import { IQC_COMPETITION_ID, IQC2026_DIALOG_DEADLINE } from '../constants';
import { getLocalStorageItem, setLocalStorageItem } from './local-storage';

/** localStorage key for tracking whether the user dismissed the IQC2026 dialog */
export const IQC2026_DIALOG_SHOWN_KEY = 'iqc2026DialogShown';

/**
 * Check if the IQC2026 enrollment dialog should be re-shown for a REJECTED user.
 * Returns true if:
 * - The competition is IQC2026S1
 * - The user hasn't already dismissed the dialog (localStorage)
 * - The deadline hasn't passed
 */
export const shouldReshowIQC2026Dialog = (competitionId: string, status: string, userId: string, now: Date = new Date()): boolean => {
  return (
    status === 'REJECTED' &&
    competitionId === IQC_COMPETITION_ID &&
    !getLocalStorageItem(userId, IQC2026_DIALOG_SHOWN_KEY) &&
    now < IQC2026_DIALOG_DEADLINE
  );
};

/**
 * Mark the IQC2026 dialog as shown/dismissed for a specific user.
 */
export const markIQC2026DialogShown = (userId: string): void => {
  setLocalStorageItem(userId, IQC2026_DIALOG_SHOWN_KEY, true);
};
